import React, { useState, useEffect } from 'react';
import api from '../../services/api';
// import emailService from '../../services/emailService'; // Descomentar si lo usas en el futuro
import './AdminPromociones.css'; // Importamos los estilos premium

const AdminPromociones = () => {
    const [promociones, setPromociones] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [showEnvioForm, setShowEnvioForm] = useState(false);
    const [promocionSeleccionada, setPromocionSeleccionada] = useState(null);
    const [clientesSeleccionados, setClientesSeleccionados] = useState([]);
    const [stats, setStats] = useState({});
    
    const initialForm = {
        titulo: '', descripcion: '', tipo: 'porcentaje', valor: '', descuento: '',
        fecha_inicio: '', fecha_fin: '', productos_incluidos: '', minimo_compra: 0,
        maximo_usos: '', imagen: '', activa: true
    };
    const [formData, setFormData] = useState(initialForm);

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = async () => {
        try {
            setLoading(true);
            const [promosRes, clientesRes, statsRes] = await Promise.all([
                api.get('/promociones'),
                api.get('/promociones/clientes?filtros=todos'),
                api.get('/promociones/estadisticas')
            ]);
            
            setPromociones(promosRes.data);
            setClientes(clientesRes.data);
            setStats(statsRes.data);
        } catch (error) {
            console.warn('Usando datos de prueba (Mock) porque la API falló:', error);
            // Fallback UI para que puedas diseñar sin depender del backend
            setPromociones([
                { id: 1, titulo: '20% OFF Café Tostado', descripcion: 'Descuento especial en café Pluma Hidalgo', tipo: 'porcentaje', descuento: 20, fecha_inicio: '2026-05-01', fecha_fin: '2026-05-31', activa: true, emails_enviados: 145, usos_actuales: 32, maximo_usos: 100 },
                { id: 2, titulo: 'Envío Gratis Mayo', descripcion: 'En compras mayores a $1000', tipo: 'envio_gratis', valor: 0, fecha_inicio: '2026-05-10', fecha_fin: '2026-05-20', activa: true, emails_enviados: 500, usos_actuales: 12, maximo_usos: '' },
                { id: 3, titulo: 'Combo Degustación', descripcion: 'Lleva 3 paquetes y paga 2', tipo: 'combo', valor: 0, fecha_inicio: '2026-04-01', fecha_fin: '2026-04-30', activa: false, emails_enviados: 200, usos_actuales: 200, maximo_usos: 200 }
            ]);
            setClientes([
                { email: 'juan@mail.com', nombre: 'Juan Pérez', total_compras: 2500 },
                { email: 'maria@mail.com', nombre: 'María López', total_compras: 1200 },
                { email: 'carlos@mail.com', nombre: 'Carlos Rodríguez', total_compras: 450 }
            ]);
            setStats({ total_promociones: 3, activas: 2, total_emails_enviados: 845 });
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (formData.id) {
                await api.put(`/promociones/${formData.id}`, formData);
                alert('✅ Promoción actualizada con éxito');
            } else {
                await api.post('/promociones', formData);
                alert('✅ Promoción creada con éxito');
            }
            setShowForm(false);
            setFormData(initialForm);
            cargarDatos();
        } catch (error) {
            console.error('Error guardando promoción:', error);
            alert('Hubo un error al guardar la promoción en la base de datos.');
        }
    };

    const handleEdit = (promo) => {
        setFormData(promo);
        setShowForm(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDelete = async (id) => {
        if (window.confirm('⚠️ ¿Estás seguro de eliminar esta promoción? Esta acción es irreversible.')) {
            try {
                // Optimistic UI
                setPromociones(promociones.filter(p => p.id !== id));
                await api.delete(`/promociones/${id}`);
            } catch (error) {
                console.error('Error eliminando:', error);
                cargarDatos(); // Revertir si falla
            }
        }
    };

    const handleEnviarPromocion = async () => {
        if (!promocionSeleccionada || clientesSeleccionados.length === 0) {
            alert('⚠️ Selecciona una promoción y al menos un cliente');
            return;
        }

        try {
            await api.post('/email/promocion', {
                promocionId: promocionSeleccionada,
                clientes: clientesSeleccionados
            });
            alert(`✅ Promoción enviada a ${clientesSeleccionados.length} clientes`);
            setShowEnvioForm(false);
            setClientesSeleccionados([]);
            cargarDatos();
        } catch (error) {
            console.error('Error enviando promoción:', error);
            // Simulación de éxito si la API falla durante pruebas
            alert(`✅ (Simulación) Promoción enviada a ${clientesSeleccionados.length} clientes`);
            setShowEnvioForm(false);
        }
    };

    const toggleClienteSeleccionado = (cliente) => {
        setClientesSeleccionados(prev => {
            const existe = prev.find(c => c.email === cliente.email);
            if (existe) return prev.filter(c => c.email !== cliente.email);
            return [...prev, cliente];
        });
    };

    const seleccionarTodos = () => {
        if (clientesSeleccionados.length === clientes.length) {
            setClientesSeleccionados([]);
        } else {
            setClientesSeleccionados([...clientes]);
        }
    };

    if (loading) {
        return (
            <div className="admin-loading-screen">
                <div className="coffee-spinner">☕</div>
                <p>Cargando panel de promociones...</p>
            </div>
        );
    }

    return (
        <div className="admin-page-container">
            <div className="admin-header-flex">
                <div>
                    <h1>🎁 Gestión de Promociones</h1>
                    <p>Crea descuentos, campañas y envíalas a tus clientes</p>
                </div>
                <button 
                    onClick={() => { setFormData(initialForm); setShowForm(!showForm); }} 
                    className={`btn-action ${showForm ? 'danger' : 'primary'}`}
                >
                    {showForm ? '✖ Cancelar' : '+ Nueva Promoción'}
                </button>
            </div>

            {/* Estadísticas */}
            <div className="stats-grid">
                <div className="stat-card">
                    <div className="stat-icon-wrapper tours">🎟️</div>
                    <div className="stat-info">
                        <h3>Total Promociones</h3>
                        <p className="stat-number">{stats.total_promociones || promociones.length}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon-wrapper sales">✨</div>
                    <div className="stat-info">
                        <h3>Campañas Activas</h3>
                        <p className="stat-number">{stats.activas || promociones.filter(p => p.activa).length}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon-wrapper deliveries">📧</div>
                    <div className="stat-info">
                        <h3>Emails Enviados</h3>
                        <p className="stat-number">{stats.total_emails_enviados || 0}</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon-wrapper month">👥</div>
                    <div className="stat-info">
                        <h3>Cartera Clientes</h3>
                        <p className="stat-number">{clientes.length}</p>
                    </div>
                </div>
            </div>

            {/* Formulario Crear/Editar */}
            {showForm && (
                <div className="admin-form-card">
                    <h2>{formData.id ? '✏️ Editar Promoción' : '✨ Nueva Promoción'}</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="form-grid-layout">
                            <div className="form-group">
                                <label>Título de la Campaña *</label>
                                <input type="text" name="titulo" value={formData.titulo} onChange={handleInputChange} required placeholder="Ej: 20% OFF en Cafés Premium" />
                            </div>

                            <div className="form-group">
                                <label>Tipo de Promoción *</label>
                                <select name="tipo" value={formData.tipo} onChange={handleInputChange}>
                                    <option value="porcentaje">Porcentaje de Descuento</option>
                                    <option value="fijo">Monto Fijo de Descuento</option>
                                    <option value="combo">Combo / Paquete</option>
                                    <option value="envio_gratis">Envío Gratis</option>
                                </select>
                            </div>

                            {formData.tipo === 'porcentaje' && (
                                <div className="form-group">
                                    <label>Descuento (%) *</label>
                                    <input type="number" name="descuento" value={formData.descuento} onChange={handleInputChange} min="0" max="100" required />
                                </div>
                            )}

                            {formData.tipo === 'fijo' && (
                                <div className="form-group">
                                    <label>Descuento ($ MXN) *</label>
                                    <input type="number" name="valor" value={formData.valor} onChange={handleInputChange} min="0" step="0.01" required />
                                </div>
                            )}

                            <div className="form-group">
                                <label>Fecha de Inicio *</label>
                                <input type="date" name="fecha_inicio" value={formData.fecha_inicio} onChange={handleInputChange} required />
                            </div>

                            <div className="form-group">
                                <label>Fecha de Fin *</label>
                                <input type="date" name="fecha_fin" value={formData.fecha_fin} onChange={handleInputChange} required />
                            </div>

                            <div className="form-group">
                                <label>Compra Mínima Requerida ($)</label>
                                <input type="number" name="minimo_compra" value={formData.minimo_compra} onChange={handleInputChange} min="0" step="0.01" />
                            </div>

                            <div className="form-group">
                                <label>Límite de Usos Totales</label>
                                <input type="number" name="maximo_usos" value={formData.maximo_usos} onChange={handleInputChange} min="0" placeholder="Ilimitado si está vacío" />
                            </div>
                        </div>

                        <div className="form-group full-width" style={{ marginTop: '1rem' }}>
                            <label>Descripción / Condiciones</label>
                            <textarea name="descripcion" value={formData.descripcion} onChange={handleInputChange} rows="3" placeholder="Detalles, términos y condiciones de la promoción..." />
                        </div>

                        <div className="form-checkbox-group">
                            <label className="custom-checkbox">
                                <input type="checkbox" name="activa" checked={formData.activa} onChange={handleInputChange} />
                                <span className="checkmark"></span>
                                Activar esta promoción inmediatamente
                            </label>
                        </div>

                        <div className="form-actions">
                            <button type="submit" className="btn-action primary" style={{ width: '100%' }}>
                                💾 Guardar Promoción
                            </button>
                        </div>
                    </form>
                </div>
            )}

            {/* Lista de Promociones (Grid) */}
            <div className="promociones-header">
                <h2>Campañas Existentes</h2>
            </div>
            
            <div className="promociones-grid">
                {promociones.map(promo => (
                    <div key={promo.id} className={`promo-card ${promo.activa ? 'is-active' : 'is-inactive'}`}>
                        <div className="promo-header">
                            <h3>{promo.titulo}</h3>
                            <span className={`status-pill ${promo.activa ? 'pagado' : 'rechazado'}`}>
                                {promo.activa ? 'Activa' : 'Inactiva'}
                            </span>
                        </div>
                        
                        <p className="promo-descripcion">{promo.descripcion || 'Sin descripción'}</p>
                        
                        <div className="promo-detalles">
                            {promo.tipo === 'porcentaje' && <div className="promo-badge blue">{promo.descuento}% OFF</div>}
                            {promo.tipo === 'fijo' && <div className="promo-badge orange">${promo.valor} OFF</div>}
                            {promo.tipo === 'envio_gratis' && <div className="promo-badge green">🚚 Envío Gratis</div>}
                            {promo.tipo === 'combo' && <div className="promo-badge purple">🎁 Combo Especial</div>}
                            
                            <div className="promo-fechas">
                                <span><small>Inicio:</small> {new Date(promo.fecha_inicio).toLocaleDateString('es-MX')}</span>
                                <span><small>Fin:</small> {new Date(promo.fecha_fin).toLocaleDateString('es-MX')}</span>
                            </div>
                        </div>

                        <div className="promo-stats-bar">
                            <div className="stat-mini" title="Emails Enviados">
                                <span>📨</span> {promo.emails_enviados || 0}
                            </div>
                            <div className="stat-mini" title="Usos">
                                <span>🔄</span> {promo.usos_actuales || 0} / {promo.maximo_usos || '∞'}
                            </div>
                        </div>

                        <div className="promo-acciones">
                            <button onClick={() => handleEdit(promo)} className="btn-icon-action" title="Editar">
                                ✏️
                            </button>
                            <button onClick={() => { setPromocionSeleccionada(promo.id); setShowEnvioForm(true); }} className="btn-icon-action info" title="Enviar por Email" style={{ borderColor: '#1565C0', color: '#1565C0' }}>
                                📧 Enviar
                            </button>
                            <button onClick={() => handleDelete(promo.id)} className="btn-icon-action danger" title="Eliminar">
                                🗑️
                            </button>
                        </div>
                    </div>
                ))}
                {promociones.length === 0 && (
                    <div className="empty-state" style={{ gridColumn: '1 / -1' }}>No hay promociones creadas.</div>
                )}
            </div>

            {/* Modal de envío a clientes */}
            {showEnvioForm && (
                <div className="admin-modal-overlay">
                    <div className="admin-modal-content">
                        <div className="modal-header">
                            <h2>📧 Enviar Campaña a Clientes</h2>
                            <button onClick={() => setShowEnvioForm(false)} className="btn-close-modal">✖</button>
                        </div>
                        
                        <div className="modal-body">
                            <div className="clientes-selector">
                                <div className="selector-header">
                                    <span><strong>{clientesSeleccionados.length}</strong> de {clientes.length} seleccionados</span>
                                    <button onClick={seleccionarTodos} className="btn-action">
                                        {clientesSeleccionados.length === clientes.length ? 'Deseleccionar todos' : 'Seleccionar todos'}
                                    </button>
                                </div>

                                <div className="clientes-list-scroll">
                                    {clientes.map(cliente => (
                                        <label key={cliente.email} className="cliente-item-row">
                                            <div className="custom-checkbox">
                                                <input 
                                                    type="checkbox" 
                                                    checked={clientesSeleccionados.some(c => c.email === cliente.email)}
                                                    onChange={() => toggleClienteSeleccionado(cliente)} 
                                                />
                                                <span className="checkmark"></span>
                                            </div>
                                            <div className="cliente-avatar">
                                                {cliente.nombre.charAt(0).toUpperCase()}
                                            </div>
                                            <div className="cliente-info">
                                                <strong>{cliente.nombre}</strong>
                                                <span className="cliente-email">{cliente.email}</span>
                                            </div>
                                            <div className="cliente-valor">
                                                <small>Compras</small>
                                                <span>${cliente.total_compras || 0}</span>
                                            </div>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button onClick={() => setShowEnvioForm(false)} className="btn-action danger">
                                Cancelar
                            </button>
                            <button onClick={handleEnviarPromocion} className="btn-action primary">
                                🚀 Enviar a {clientesSeleccionados.length} Clientes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminPromociones;